import './i18n'
import './index.css'
import './styles/index.scss'

import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/lib/integration/react'

import App from './app'
import createReduxStore from './redux/store/setup'

import { createRoot } from 'react-dom/client'

const { store, persistor } = createReduxStore()

createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
)
